import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMask1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMask1"><Path fillRule="evenodd" clipRule="evenodd" d="M20 5.24609V7.5H23V14H20V15.2637C20 16.4 19.3581 17.4391 18.3418 17.9473L12 21.1182L5.6582 17.9473C4.64191 17.4391 4 16.4 4 15.2637V14H1V7.5H4V5.24609L12 2.95996L20 5.24609ZM9 15H15V13H9V15ZM3 12H4V9.5H3V12ZM20 12H21V9.5H20V12ZM9 11H15V9H9V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMask1;
